import { useHistory } from "react-router";
import './variables.css';
import './LogInn/StylesLogin.css';

function MinProfil() {

    const history = useHistory(); 

  const HandleButtonClick = () => {
    history.push('/tab3');
  }
    

    return(
        <html>
            <body >
                <div  className="tab3">
                    <h1><strong>Min profil</strong></h1>
                    <br></br>
                    <p>
                        
                        <br></br>
                        Meldal Videregående Skole
                        <br></br>
                        VG3 - Dataelektronikerfaget
                        <br></br>
                        Skoleåret 2022-2023
                    </p>
                    <br></br>
                    <p>
                        Tusen takk for at du bruker denne appen
                    </p>
                    <br></br>
                    <button onClick={HandleButtonClick}>Tilbake</button>
                   
                </div>
            </body>
        </html>
    );
};

export default MinProfil;